import CloseSVG from "@design-system/ui-icons/vanilla/Close"
import { createIcon } from "../createIcon"

export const CloseIcon = createIcon(CloseSVG)
